import React, { Fragment, useState } from 'react';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { Icon, ICONS } from 'components/Icons';
import classNames from 'classnames';
import { Modal, Button } from 'react-bootstrap';
import FT from 'assets/images/NewsChallenge/ft.png';

import './NewsChallenge.scss';

export default function NewsChallenge() {
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);

  function renderTitle() {
    return (
      <div className="bg-av-blue av-white">
        <div className="text-center section container">
          <h2 className="news-challenge-title mt-0">The News Challenge</h2>
          <h3 className="news-challenge-dates mt-0">June 15 to August 17</h3>
          <p className="news-challenge-subtitle">
            a reading competition that motivates university and high school
            students to develop their media literacy
          </p>
          <RectangularButton
            className="learn-more-btn mt-4"
            onClick={() => {
              setShowLearnMoreModal(true);
            }}
          >
            Sign up
          </RectangularButton>
          {renderBenefits()}
        </div>
      </div>
    );
  }

  function renderHostedBy() {
    return (
      <div className="section bg-gray-1">
        <div className="news-challenge-subtitle d-flex justify-content-center">
          Hosted by
          <div className="d-flex flex-column align-items-center mx-2">
            <div className="font-weight-600">AverPoint</div>
            <Icon icon={ICONS.LOGO_NO_TEXT} size={30} className="mt-2" />
          </div>
          and
          <div className="d-flex flex-column align-items-center mx-2">
            <div className="font-weight-600">The Financial Times</div>
            <img src={FT} height={26} className="mt-2" />
          </div>
        </div>
      </div>
    );
  }

  function renderTestimonials() {
    return (
      <div className="section container testimonials-container">
        <div className="row d-md-flex align-items-center">
          <div className="col-md-5">
            <h3 className="av-blue my-0 font-weight-600 text-center ">
              Over 100 participating schools in 16 countries            
            </h3>
          </div>
          <div className="col-md-7 mt-4 mt-md-0" style={{ overflow: 'hidden' }}>
            <div className="gradient"></div>
            <div
              className="d-flex align-items-center testimonials"
              style={{ width: 'max-content' }}
            >
              {[
                {
                  quote: 'The program has transformed my reading diet.',
                  from: '10th year student, Eton College',
                },
                {
                  quote:
                    'The Challenge helped form a habit of reading multiple newspapers every day',
                  from: 'Year 12 student, Cardiff Sixth Form College',
                },
                {
                  quote:
                    'It was really interesting to learn about different things going on in the world, and how they have an impact on other countries and people. I like the range of sources it has and the summary stats so you can see what you read and how often',
                  from: 'Year 12 student, London Academy of Excllence',
                },
                {
                  quote:
                    'The Challenge was a great opportunity read the news and learn about current events. The curated readings were interesting and insightful.',
                  from: 'Year 11 student, Harrow School',
                },
                {
                  quote:
                    'For me, the best part is the distinct tracking feature. I use it to understand what I am reading.',
                  from: 'Year 12 student, Langley Grammar School',
                },
              ].map((i, index) => {
                return (
                  <div className="flex-shrink-0 testimony" key={index}>
                    <p className="my-0 font-weight-600">{i.quote}</p>
                    <p className="my-0">
                      <i>- {i.from}</i>
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderBanner() {
    return (
      <div className="container">
        <div className="banner section">
          <img
            src="https://res.cloudinary.com/averpoint/image/upload/v1735573654/news-challenge/news_challenge.png"
            className="banner-img"
          />
        </div>
      </div>
    );
  }

  function renderBenefits() {
    return (
      <div className="container section pb-0">
        <div className="row">
          {[
            'Engage with high-quality sources',
            'Build a healthy reading diet',
            'Practice media literacy every day',
          ].map((i, index) => (
            <div
              key={index}
              className={classNames('col-md-4', {
                'mt-4 mt-lg-0': index !== 0,
              })}
            >
              <div className="d-flex align-items-center p-4">
                <Icon
                  icon={ICONS.CHECK}
                  size={30}
                  className="av-green flex-shrink-0"
                />
                <h3 className="flex-fill my-0 ml-4 text-left font-size-16">
                  {i}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  function renderHowItWorks() {
    return (
      <div className="bg-av-light-blue section">
        <div className="container">
          <div className="row">
            <div className="col-md-offset-1 col-md-10">
              <h2 className="how-it-works-title">How it works</h2>
              {renderReadingGoals()}
              {renderNewsWebsite()}
              {renderBEMeasuresProgress()}
              {renderNewWeeklyGoals()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderReadingGoals() {
    return (
      <div className="section">
        <div className="row">
          <div className="col-md-6">
            <h3 className="title mt-0">Reading goals</h3>
            <div>On Sunday, students get weekly goals that improve their</div>
            <ul>
              <li>reading diet</li>
              <li>critical thinking</li>
              <li>metacognition</li>
            </ul>
            <div> It’s 10 to 30 minutes of work per week.</div>
          </div>
          <div className="col-md-6">
            <img
              src="https://res.cloudinary.com/averpoint/image/upload/v1735571228/news-challenge/reading_goals.png"
              className="w-100 section-img"
            />
          </div>
        </div>
      </div>
    );
  }

  function renderNewsWebsite() {
    return (
      <div className="section">
        <div className="row">
          <div className="col-md-6">
            <img
              src="https://res.cloudinary.com/averpoint/image/upload/v1735571228/news-challenge/news_websites.png"
              className="w-100 section-img"
            />
          </div>
          <div className="col-md-6">
            <h3 className="title mt-0">Real websites</h3>
            <div>Students read on real news websites.</div>
            <ul>
              <li>Over 2,000 approved news sources</li>
              <li>Teacher can add links, pasted text, or PDFs</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  function renderBEMeasuresProgress() {
    return (
      <div className="section">
        <div className="row">
          <div className="col-md-6">
            <h3 className="title mt-0">Measure progress</h3>
            <div>AverPoint’s browser extension</div>
            <ul>
              <li>Measures reading time</li>
              <li>Powers critical interactions with text</li>
              <li>Generates an in article quiz</li>
              <li>Works with Chrome, Safari, Edge, and Firefox</li>
              {/* <ul>
                <li>Reading time</li>
                <li>Interactions with text</li>
                <li>In-article quiz responses</li>
              </ul> */}
            </ul>
          </div>
          <div className="col-md-6">
            <img
              src="https://res.cloudinary.com/averpoint/image/upload/v1735571228/news-challenge/be_measures_progress.png"
              className="w-100 section-img"
            />
          </div>
        </div>
      </div>
    );
  }

  function renderNewWeeklyGoals() {
    return (
      <div className="section">
        <div className="row">
          <div className="col-md-6">
            <img
              src="https://res.cloudinary.com/averpoint/image/upload/v1735571228/news-challenge/weekly_goals.png"
              className="w-100 section-img"
            />
          </div>
          <div className="col-md-6">
            <h3 className="title mt-0">Weekly improvement</h3>
            On Sunday, we promote or demote students... and send new weekly
            goals.
          </div>
        </div>
      </div>
    );
  }

  function renderTheIncentives() {
    return (
      <div className="section">
        <h3 className="title mt-0 mb-4">The incentives</h3>
        <div>
          Students who reach Level 6 on AverPoint will receive
        </div>
        <ul>
          <li>A letter of merit from the Finanical Times and AverPoint</li>
          <li>An invitation to a webinar with an FT journalist and a policy expert</li>
        </ul>
      </div>
    );
  }

  function renderTheSources() {
    return (
      <div className="section">
        <h3 className="title mt-0 mb-4">The sources</h3>
        <div>
          Students get credit for reading articles from over 2,000 high-quality
          news sources. These publications follow journalistic practices and
          have a process for
        </div>
        <ul>
          <li>Editorial review</li>
          <li>Fact-checking</li>
          <li>Sourcing</li>
          <li>Retraction</li>
          <li>Plagiarism</li>
        </ul>
        <p>
          Teachers can assign specific sources and articles, even if not
          approved by AverPoint.
        </p>
        <p>
          Read about our{' '}
          <a href="/help-page?helpId=66eb5856ef6401048f53549f">
            source approval process
          </a>
          .
        </p>
      </div>
    );
  }

  function renderTheTimeCommitment() {
    return (
      <div className="section">
        <h3 className="title mt-0 mb-4">The time commitment</h3>
        <p>Students read about 30 minutes a week.</p>
        <p>There’s no work for teachers, besides initial set up.</p>
      </div>
    );
  }

  function renderTheVision() {
    return (
      <div className="section">
        <h3 className="title mt-0 mb-4">The vision</h3>
        <p>
          The Reading Challenge aims to help students practice media literacy in
          the real digital world. This starts by building a habit of daily
          reading from a variety of high-quality sources. As students advance
          levels, they also learn to responsibly critique what they read.
        </p>
      </div>
    );
  }

  function renderWhoIsInvolved() {
    return (
      <div className="section">
        <h3 className="title mt-0 mb-4">Who is involved?</h3>
        <p>
          The Reading Challenge is hosted by AverPoint and the Financial Times.
          Participants can receive
          &nbsp; 
          <a
            href="https://professional.ft.com/en-gb/services/professional-subscriptions/secondary-education/"
            target="_blank"
            key="sourceURL"
            onClick={(e) => e.stopPropagation()}
          >
            free access to the Financial Times
          </a>
          .
        </p>
      </div>
    );
  }

  function renderTheCost() {
    return (
      <div className="section">
        {/* <h3 className="title mt-0 mb-4">The cost</h3>
        <p>The Reading Challenge costs $100 per school. </p> */}
      </div>
    );
  }

  function renderLearnMoreModal() {
    if (!showLearnMoreModal) {
      return null;
    }

    return (
      <LearnMoreModal
        onClose={() => {
          setShowLearnMoreModal(false);
        }}
      />
    );
  }

  return (
    <Fragment>
      <div className="bg-av-white news-challenge-page">
        {renderTitle()}
        {/* {renderBenefits()} */}
        {renderHostedBy()}
        {renderTestimonials()}
        {renderBanner()}
        {renderHowItWorks()}
        <div className="container">
          <div className="row">
            <div className="col-md-offset-1 col-md-10">
              {renderTheIncentives()}
              {renderTheSources()}
              {renderTheTimeCommitment()}
              {renderTheVision()}
              {renderWhoIsInvolved()}
              {renderTheCost()}
            </div>
          </div>
        </div>
      </div>
      {renderLearnMoreModal()}
    </Fragment>
  );
}

function LearnMoreModal({ onClose }) {
  return (
    <Modal show={true} className="news-challenge-learn-more-modal">
      <Modal.Header>
        <Modal.Title>
          <h3 className="m-0 font-weight-600">
            Sign up for the News Challenge
          </h3>
        </Modal.Title>
        <Button bsStyle="link" className="btn-close" onClick={onClose}>
          <Icon icon={ICONS.CLOSE} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <a
              className="card"
              href="https://forms.gle/3n9JCktBrUy3rMz38"
              target="_blank"
            >
              I am a student
            </a>
          </div>
          <div className="col-md-6">
            <a
              className="card"
              href="https://forms.gle/UiGCu7YtLB6Wk4hz5"
              target="_blank"
            >
              I am a teacher
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
